export const CHANGE_SHOW_CATEGORY = 'CHANGE_SHOW_CATEGORY'
export const SET_IMPORTANT_COURSE = 'SET_IMPORTANT_COURSE'
export const SET_COURSE_GROUPS = 'SET_COURSE_GROUPS'
export const SET_SELECTED_GROUP_COURSE = 'SET_SELECTED_GROUP_COURSE'
export const SET_SELECTED_ACTIVE = 'SET_SELECTED_ACTIVE'
